import { defineAsyncComponent } from 'vue';

const Tiktok_TYPE = 5;

export default {
    emits: ['update:height'],
    props: {
        images: {
            type: Array,
            default: () => []
        },
        content: {
            type: String,
            default: ''
        },
        createTime: {
            type: Number,
            default: 0
        },
        socialType: {
            type: Number,
            default: 0
        },
        url: {
            type: String,
            default: ''
        },
        channelId: {
            type: [String, Number],
            default: ''
        },
        pageName: {
            type: String,
            default: ''
        }
    },
    components: {
        imgSwiper: defineAsyncComponent(() => import(/* webpackChunkName: "common/img-swiper" */ '@/components/img-swiper.vue'))
    },
    data: function() {
        return {
            imageWH: {
                naturalWidth: 0,
                naturalHeight: 0,
                id: ''
            },
            width: 235,
            previewIndex: 0,
            isMobileDevice: this.platform.isMobile,
            Tiktok_TYPE
        };
    },
    computed: {
        imagesJson() {
            return JSON.stringify(this.images);
        },
        imgHeight() {
            let calcHeight = Math.ceil(this.width);
            if (this.imageWH.naturalWidth) {
                calcHeight = Math.ceil(
                    (this.imageWH.naturalHeight * this.width) /
                        this.imageWH.naturalWidth
                );
            }
            return Math.min(300, Math.max(calcHeight, 210));
        },
        sourceClass() {
            switch (this.socialType) {
            case 1:
                return 'icon-instagram';
            case 0:
                return 'icon-facebook-round';
            case 2:
                return 'icon-newtwitter-round';
            case 3:
                return 'icon-linkedin-round';
            case 4:
                return 'icon-youtube-fill';
            case 5:
                return 'icon-tiktok-round';
            case 6:
                return 'icon-facebook-round';
            case 7:
                return 'icon-google-plus-round';
            }
            return '';
        },
        sourceStyle() {
            switch (this.socialType) {
            case 1:
                return {};
            case 0:
                return { color: '#384891' };
            case 2:
                return { color: '#1daef3' };
            case 3:
                return { color: '#2f8ad9' };
            case 4:
                return { color: '#ed0a0a' };
            case 5:
                return { color: '#000000' };
            case 6:
                return { color: '#384891' };
            case 7:
                return { color: '#4ea3f0' };
            }
            return '';
        }
    },
    mounted() {
        this.tellOutterHeight();
    },
    methods: {
        onImageLoad(event) {
            let { width, height } = event || {};
            if (this.imageWH.id == this.channelId) {
                return;
            }
            this.imageWH.naturalWidth = width;
            this.imageWH.naturalHeight = height;
            this.imageWH.id = this.channelId;
            this.tellOutterHeight();
        },
        tellOutterHeight() {
            this.$nextTick(_ => {
                this.width = this.$el.clientWidth;
                return this.$emit('update:height', this.$el.offsetHeight);
            });
        },
        onPreviewChange(idx) {
            this.previewIndex = idx - 1;
        },
        changePreview(event, command) {
            if (!this.$refs.imgSwiper) {
                return;
            }
            this.$refs.imgSwiper.switchImg(event, command);
        }
    }
};
